import React from 'react';
import ReactDOM from 'react-dom';
import { FormRenderProps } from 'react-final-form';

export interface IFormButtonsProps {
  form: FormRenderProps;
  formId: string;
  buttons?: (form: FormRenderProps, formId: string) => React.ReactNode;
  buttonsPortal?: () => HTMLElement;
}

export default function FormButtons({ form, formId, buttons, buttonsPortal }: IFormButtonsProps): React.ReactElement {
  const _buttons = buttons ? buttons(form, formId) : null;

  return (
    <>
      {_buttons && buttonsPortal && buttonsPortal() && ReactDOM.createPortal(_buttons, buttonsPortal())}
      {_buttons && (!buttonsPortal || !buttonsPortal()) && <div className="gik-form__actions">{_buttons}</div>}
    </>
  );
}
